import _ from 'lodash'
import { ConceptStatusValue } from "@fusion-advantage/backcompat"
import { shallowEqual } from '../shallowEqual'

// @deprecated: 20241120
// now in use only by L4TabularList,
// may eventually replace with some sensible redux-based solution
export class ConceptValueModelList<T> {
	private existingList: Array<T>
	list: Array<T>

	constructor(statusValue: ConceptStatusValue) {
		if(_.isString(statusValue) && statusValue !== '') {
			// TODO proper error handling 
			this.existingList = JSON.parse(statusValue)
		} else {
			this.existingList = []
		}
		this.list = [ ...this.existingList ]
	}

	toJson() {
		return JSON.stringify(this.list)
	}

	// This expects redux-style updates;
	// do not update an object in the internal list directly;
	// replace the object when it needs to be updated
	isUpdated() {
		return !shallowEqual(this.list, this.existingList)
	}

	itemIdxByKey(keyName: string): _.Dictionary<number> {
		return _.fromPairs(_.map(this.list, (item, idx) => [_.get(item, keyName), idx]))
	}

	removeItemsByIdx(idxs: number[]) {
		if(idxs.length > 0) {
			this.list = _.reject(this.list, (_item, itemIdx) => idxs.includes(itemIdx))
		}
	}
}
